<template>
  <div>
    <el-table :data="pagedTableData" style="width: 100%" border :page-size="pageSize" empty-text="No data available.">
      <el-table-column prop="Species" label="Species" width="100" :sortable="true" :sort-method="createSortMethod('Species')">
        <template v-slot="{ row }">
          <span class="text">{{ row.Species }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Tissue" label="Tissue" :sortable="true" :sort-method="createSortMethod('Tissue')">
        <template v-slot="{ row }">
          <span class="text">{{ row.Tissue }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Stage" label="Stage" :sortable="true" :sort-method="createSortMethod('Stage')">
        <template v-slot="{ row }">
          <span class="text">{{ row.Stage }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Type" label="Type" width="180" :sortable="true" :sort-method="createSortMethod('Type')">
        <template v-slot="{ row }">
          <span class="text">{{ row.Type }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Geo" label="GEO" width="200" :sortable="true" :sort-method="createSortMethod('Geo')">
        <template v-slot="{ row }">
          <a
            :href="getGEOUrl(row.Geo)"
            target="_blank"
            style="text-decoration: none; color: #5E86F5;"
          >
            <span>{{ row.Geo }}</span>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="Encode" label="ENCODE" width="200" :sortable="true" :sort-method="createSortMethod('Encode')">
        <template v-slot="{ row }">
          <a
            :href="getEncodeUrl(row.Encode)"
            target="_blank"
            style="text-decoration: none; color: #5E86F5;"
          >
            <span>{{ row.Encode }}</span>
          </a>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="currentPageRange"
        :page-size="pageSize"
        :total="tableData.length"
        :page-count="pageCount"
        @current-change="handleCurrentChange"
        :background="true"
        layout="prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      url: "http://183.175.59.4/devenhancer/rawdata/",
      currentPageRange: 1,
      pageSize: 10,
    };
  },
  computed: {
    // 计算分页后的数据
    pagedTableData() {
      const startIndex = (this.currentPageRange - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.tableData.slice(startIndex, endIndex);
    },
    // 计算总页数
    pageCount() {
      return Math.ceil(this.tableData.length / this.pageSize);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$axios.get(this.url,)
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    handleRowClick(row, event, column) {
      // 处理行点击事件
      console.log('Row clicked:', row);
    },
    handleCurrentChange(val) {
      this.currentPageRange = val;
    },
    getGEOUrl(geo) {
      return geo === 'NA' ? 'javascript:void(0);' : `https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=${geo}`;
    },
    getEncodeUrl(encode) {
      return encode === 'NA' ? 'javascript:void(0);' : `https://www.encodeproject.org/search/?searchTerm=${encode}`;
    },
    // 创建自定义的排序函数
    createSortMethod(column) {
      return (a, b) => a[column].localeCompare(b[column]);
    },
  },
};
</script>

<style scoped>
.text {
  color: #909399;
}
.pagination {
  text-align: center;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/statistics/Rawtable.vue